<template>
  <!--内容  end-->
  <div class="footer_out">
    <div class="footer w1100" v-html="bottom">
      
    </div>
    <p>
      <span style="color: #ffffff">Copyright 2010-2020    </span><span
        v-show="pageInformationIsshow"
        v-html="versionNumber"
        style="color: yellow; font-weight: bold"
      >
        版本号：4.0.0</span
      >
    </p>
  </div>
</template>

<script>
import "../../../static/css/style.css";
export default {
  data() {
    return {
      bottom:"",
      versionNumber: "", //版本号
      code: "versionNumber",
      pageInformationIsshow: false,
    };
  },
  methods: {
     //获取版本号
     getversionNumber() {
      var that=this;
      var posturl =
        this.config.baseUrl.pro +
        "/Base_Config/apiGetPagedBase_Configs?page=1&limit=1&KeyWord="+ this.code;
      axios
        .request({
          url: posturl,
          methods: "get",
          changeOrigin: true,
        })
        .then((resp) => {
          if (
            resp.data.result.data != null &&
            resp.data.result.data != undefined &&
            resp.data.result.data != ""
          ) {
            this.pageInformationIsshow = true;

            that.versionNumber = "版本号："+resp.data.result.data[0].value;
            //this.versionNumber = resp.data.result.data[0].remark;
            //this.formData.id = resp.data.result.data[0].id;
          } else {
            this.pageInformationIsshow = false;
          }
        })
        .catch((err) => {
          this.$Message.error("数据加载失败：" + err);
        });
    },
    getdata() {
      // console.log("数据加载");
    },
    linkclick(url) {
      window.location.href = url;
    },
    getConfig() {
      var posturl = this.config.baseUrl.pro + "/Base_Config/apiGetConfigByCod";
      return axios
        .request({
          url: posturl,
          method: "POST",
          data:{code:"bottom"}
        })
        .then((resp) => {
          console.log(resp.data.Result.Data);
          var node=resp.data.Result.Data;
          if(node!=null&&node!=undefined){
            this.bottom=node.Value;
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.loginStatus();
          console.log(err);

          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
  },
  mounted() {
    this.getConfig();
    this.getversionNumber();
  },
};
</script>
<style scoped>
.link {
  height: 50;
  width: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/webBottom/webxxBottom.vue